import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("vendorToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

// const axiosInstance = axios.create({
//   baseURL: `${API_URL}/api`,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Add token to headers if it exists
// axiosInstance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("vendorToken");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// export default axiosInstance;